module.exports = __webpack_public_path__ + "img/icon-logout-white.svg";